module.exports = __webpack_public_path__ + "static/img/login-bg.a52eee1.jpg";